import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
const LoadingDots = () => (_jsxs("div", { className: "flex items-center space-x-1", children: [_jsx("div", { className: "w-2 h-2 bg-slate-400 rounded-full animate-bounce [animation-delay:-0.3s]" }), _jsx("div", { className: "w-2 h-2 bg-slate-400 rounded-full animate-bounce [animation-delay:-0.15s]" }), _jsx("div", { className: "w-2 h-2 rounded-full bg-slate-400 animate-bounce" })] }));
export const LoadingMessage = () => {
    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 1500);
        return () => clearTimeout(timer);
    }, []);
    if (!isVisible)
        return null;
    return (_jsx("div", { className: "flex flex-col rounded-lg gap-2 max-w-[80%] items-start", children: _jsxs("div", { className: "flex items-center gap-2 text-xs text-slate-500", children: [_jsx("span", { children: "Creative Workspace AI is thinking" }), _jsx(LoadingDots, {})] }) }));
};
